/**
 * 模块名称: 退款管理
 * @author xuxiaobo@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Main from './Main'
import Add from './Add'
import NotAdd from './NotAdd' // 未认款退款
import Details from './Details'
import './assets/style.scss'

const Refund = ({ match, history }) => {

  return (
    <div>
      <Switch> 
        <Route path={match.path + '/details'} component={Details} />
        <Route path={match.path + '/edit'} component={Add} />
        <Route path={match.path + '/add'} component={Add} />
        <Route path={match.path + '/addNot'} component={NotAdd} />
        <Route path={match.path + '/editNot'} component={NotAdd} />
        <Route component={Main} />
      </Switch>
    </div>
  )
}

export default Refund